/**
 * Shared styles and helpers for dashboard cards
 */
import { cardSurface } from '../shared/Card';

export const cardStyle = {
  ...cardSurface,
  p: { base: 3, md: 5 },
};

export const cardTitle = {
  fontSize: '14px',
  fontWeight: 600,
  letterSpacing: 'tight',
  color: 'redesign.heading',
};

// A card's way out ("View all", "Movements"): a small uppercase label, so it
// never competes with the card's title.
export const viewAllStyle = {
  textStyle: 'microLabel',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  _hover: { color: 'redesign.heading' },
};
